// How much current one SSR can carry.
//
// An SSR is filled to a current budget rather than a heater count: a 20A SSR
// takes four 5A heaters, or two 10A ones. Each heater's `current` is what that
// part number draws at most, so the SSR's load is the sum across every heater
// attached to it — repeats included.
//
// ASSUMPTION: every SSR is rated 20A. If ratings ever vary per SSR this needs
// to come from the device data instead; pass an explicit capacity to
// exceedsCapacity in the meantime.
export const SSR_CURRENT_CAPACITY_A = 20;

// Sums to 3 decimal places. Heater currents are values like 3.4, and adding
// three of them gives 10.200000000000001 in binary floating point, which would
// otherwise read as over budget at the boundary.
const round = (value) => Math.round(value * 1000) / 1000;

export const totalCurrent = (specs) =>
  round(
    (Array.isArray(specs) ? specs : []).reduce((sum, spec) => {
      const current = Number(spec?.current);
      return Number.isFinite(current) ? sum + current : sum;
    }, 0),
  );

export const exceedsCapacity = (specs, capacity = SSR_CURRENT_CAPACITY_A) =>
  totalCurrent(specs) > capacity;
